import {DoBootstrap, NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {UpgradeModule} from "@angular/upgrade/static";
import {LocationUpgradeModule} from "@angular/common/upgrade";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CoreModule, CourseManagementModule, CREManagementModule, SharedModule, StudentModule} from "./ng-migration";

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    UpgradeModule,
    CourseManagementModule,
    CREManagementModule,
    StudentModule,
    LocationUpgradeModule.config({useHash:true}),
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
  ],
  providers: [],
})
export class AppModule implements DoBootstrap {
  constructor(private upgrade: UpgradeModule) {}

  public ngDoBootstrap(): void {
    // bootstrap(angularJs root element in dom, AngularJS root module, bootstrap options)
    this.upgrade.bootstrap(document.body, ["schoolwork12"], { strictDi: true });
  }
}
